export default ['Returning', 'Lead', 'Supporting', 'Series Regular', 'Recurring', 'Cameo', 'Guest Star', 'Ensemble'];

export const castingTypesByProjectType = {
  Any: ['Returning', 'Lead', 'Supporting', 'Series Regular', 'Recurring', 'Cameo', 'Guest Star', 'Ensemble'],
  Feature: ['Returning', 'Lead', 'Supporting', 'Cameo'],
  Television: ['Returning', 'Lead', 'Recurring', 'Cameo', 'Guest Star', 'Series Regular'],
  Theatre: ['Returning', 'Lead', 'Supporting', 'Ensemble'],
  Unscripted: ['Returning', 'Cameo', 'Guest Star', 'Lead', 'Recurring', 'Series Regular', 'Supporting'],
};
